import React from 'react'
import { Card, CardBody, Spinner, } from 'reactstrap'

const ProgramSearchLoading = () => <Card>
  <CardBody>
    <Spinner/> Searching...
  </CardBody>
</Card>

export default React.memo(ProgramSearchLoading)